'use strict';

import './cities.css';

import angular from 'angular';

import cities from './cities';
import cityList from './city_list/city_list';
import seoCS from './seo_cities.service';

import 'nls!./cities.json';

const dependencies = [
];

export default angular
  .module('cities', dependencies)
  .component('saCities', cities)
  .component('saCityList', cityList)
  .factory('seoCS', seoCS)
  .name;



// WEBPACK FOOTER //
// ./app/src/modules/cities/index.js